module.exports = __webpack_public_path__ + "static/paso-1-da52bfef98a2867e0c3fd8a9b2883ea8.png";